import { Typography } from "@mui/material";

export default function Subtitle1({ children }) {
	return (
		<Typography variant="subtitle1" gutterBottom component="div">
			{children}
		</Typography>
	);
}
